<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-form ref="testerform" id="testerform" v-model="valid" lazy-validation>
                <v-toolbar flat>
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-spacer />
                    <v-btn color="grey" dark class="mb-2 mr-2" @click="$router.go(-1)" small>
                        <v-icon small>mdi-arrow-left</v-icon>
                        Back
                    </v-btn>
                </v-toolbar>
                <div class="mt-3">
                    <v-row class="mx-5">
                        <v-col lg="2" md="3" sm="4" cols="4">Delivery Date</v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">
                            <v-menu v-model="dateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs}">
                                    <v-text-field v-model="date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                                </template>
                                <v-date-picker v-model="date" @change="handelChangeDate"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col lg="2" md="3" sm="4" cols="4">Volume</v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">
                            <v-select outlined dense hide-details="auto" :items="bottles" item-value="code" item-text="description" v-model="selectedBottle" @change="handleChangeBottle" />
                        </v-col>
                    </v-row>
                    <v-row class="mx-5">
                        <v-col lg="2" md="3" sm="4" cols="4">Coordinator</v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">
                            <v-skeleton-loader type="text" v-if="isLoadingCoordinator" />
                            <v-select v-else v-model="selectedCoordinator" class="compact-form" outlined dense hide-details="auto" :items="coordinators" item-text="name" item-value="code" @change="handleChangeCoordinator" clearable></v-select>
                        </v-col>
                        <v-col lg="2" md="3" sm="4" cols="4">Expired Date</v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">
                            <v-skeleton-loader type="text" v-if="isLoading" />
                            <span v-else>
                                {{ expiredDate }}
                            </span>
                        </v-col>
                        <v-col lg="2">
                            <v-btn depressed color="green" class="d-inline ms-2 white--text" @click="export2xls">Export to XLS</v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="compact-form my-2 mx-1">
                        <v-col>
                            <v-card outlined>
                                <v-skeleton-loader v-if="isLoading"
                                    v-bind="attrs"
                                    type="table-heading, list-item-two-line, table-tfoot"
                                    ></v-skeleton-loader>
                                <v-simple-table v-else class="spreadsheet-table flex-table" fixed-header height="400" ref="tabelExport">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="header-cell text-center" width="10">No</th>
                                                <th class="header-cell text-center">Code</th>
                                                <th class="header-cell text-center">Product</th>
                                                <th class="header-cell text-center">Ambil Stok Adelphi</th>
                                                <th class="header-cell text-center">Sisa</th>
                                                <th class="header-cell text-center" v-for="(outlet, ido) in outlets" :key="ido">
                                                    {{ outlet.outlet_name }}
                                                </th>
                                                <th class="header-cell text-center">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(product, idp) in filteredItems" :key="product.product_code">
                                                <td class="header-cell text-center">{{ idp + 1 }}</td>
                                                <td class="header-cell text-no-wrap">{{ product.product_code }}</td>
                                                <td class="header-cell text-no-wrap">{{ product.product_name }} ({{ product.product_size }} ML)</td>
                                                <td class="spreadsheet-cell">
                                                    <v-text-field v-model="product.quantity_from_adelphi" class="spreadsheet-input" type="number" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                    <span style="display: none;">{{ product.quantity_from_adelphi }}</span>
                                                </td>
                                                <td class="spreadsheet-cell text-center">
                                                    <v-text-field :value="calculateSisa(product)" class="disable2-input" :class="{'warning-input': isWarning(product) }" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ calculateSisa(product) }}</span>
                                                </td>
                                                <td class="spreadsheet-cell" v-for="(outlet, ido) in product.outlets" :key="ido">
                                                    <v-text-field v-model="outlet.quantity" class="spreadsheet-input" type="number" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                    <span style="display: none;">{{ outlet.quantity }}</span>
                                                </td>
                                                <td class="spreadsheet-cell text-center">
                                                    <v-text-field :value="calculateTotal(product)" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ calculateTotal(product) }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th colspan="3" class="header-text text-right">Jumlah Total</th>
                                                <th class="spreadsheet-cell text-center">
                                                    <v-text-field :value="totalQtyStokAdelphi" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ totalQtyStokAdelphi }}</span>
                                                </th>
                                                <th class="spreadsheet-cell text-center">
                                                    <v-text-field :value="totalQtySisa" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ totalQtySisa }}</span>
                                                </th>

                                                <th class="spreadsheet-cell text-center" v-for="(outlet, ido) in outlets" :key="ido">
                                                    <v-text-field :value="totalQtyOutlet(outlet.outlet_code)" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ totalQtyOutlet(outlet.outlet_code) }}</span>
                                                </th>

                                                <th class="spreadsheet-cell text-center">
                                                    <v-text-field :value="totalQtyTotal" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ totalQtyTotal }}</span>
                                                </th>
                                            </tr>
                                        </tfoot>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions class="pr-4 mt-3 mx-5">
                    <v-spacer />
                    <v-btn depressed color="primary" @click="saveTester" v-if="editedIndex === -1">
                        Submit
                    </v-btn>
                    <v-btn depressed color="primary" @click="updateTester" v-if="editedIndex > -1">
                        Update
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <v-overlay :value="saveProgress" z-index="999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import moment from 'moment';
import { utils, writeFileXLSX } from 'xlsx';

export default {
    data() {
        return {
            valid: true,
            isLoading: false,
            isLoadingCoordinator: false,
            dateMenu: false,
            saveProgress: false,
            date: '',
            expiredDate: '',
            selectedCoordinator: '',
            editedIndex: -1,
            coordinators: [],
            items: [],
            details: [],
            outlets: [],
            products: [],
            bottles: [],
            selectedBottle: '250',
            attrs: {
                class: 'mb-6',
                boilerplate: true,
                elevation: 2,
            },
        }
    },
    
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'Add Tester' : 'Edit Tester';
        },
        filteredItems() {
            return this.items.filter(item => item.product_size === this.selectedBottle);
        },
        totalQtyStokAdelphi() {
            return this.filteredItems.reduce((total, item) => total + Number(item.quantity_from_adelphi), 0);
        },
        totalQtySisa() {
            return this.filteredItems.reduce((total, item) => total + Number(this.calculateSisa(item)), 0);
        },
        totalQtyTotal() {
            return this.filteredItems.reduce((total, item) => total + Number(this.calculateTotal(item)), 0);
        }
    },

    async created() {
        this.date = moment().format('YYYY-MM-DD');
        this.isLoadingCoordinator = true;
        this.isLoading = true;

        this.getDataProducts();
        this.coordinators = (await this.$store.dispatch('coordinator/getObjs')).data.data;
        this.isLoadingCoordinator = false;

        this.getBottles();

        this.fetchDetails();
    },

    methods: {
        handelChangeDate() {
            this.fetchDetails();
        },
        handleChangeCoordinator() {
            this.fetchDetails();
        },
        handleChangeBottle() {},
        getBottles() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.bottles = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });
        },
        async getDataProducts() {
            let response = await this.$store.dispatch('variant/getObjs')
            if (response.data.status == 'success') {
                this.products = response.data.data;
                this.products = this.products.filter(p => p.is_active == 1)
                    .sort((a, b) => a.sort_no - b.sort_no);
            }
        },
        async fetchDetails() {
            this.isLoading = true;

            try {
                const paramId = this.$route.params.id;                
                const response = (await this.$store.dispatch('tester/getDetails', {
                    id: paramId,
                    date: this.date,
                    coordinator: this.selectedCoordinator
                }));

                const data = response.data.data;
                this.date = data.date;
                this.expiredDate = data.expired_date;
                const allOutlets = [
                    ...data.outlets,
                    ...data.additional_outlets
                ];
                this.outlets = allOutlets;
                this.details = data.details;
                this.selectedCoordinator = data.coordinator_code;
                
                this.items = this.products.map(product => ({
                    product_code: product.code,
                    product_name: product.name,
                    product_size: product.size,
                    quantity_from_adelphi: this.qtyFromAdelphi(product.code),
                    outlets: this.qtyOutlet(product.code),
                }));

                if (data.details.length > 0) {
                    this.editedIndex = 1;
                }
            } catch (error) {
                console.log('Error fetching testing detail:', error);
            } finally {
                this.isLoading = false;
            }
        },
        qtyFromAdelphi(productCode) {
            let result = 0;
            const detailSelected = this.details.find((product) => product.product_code == productCode);
            if (detailSelected) {
                result = detailSelected.quantity_from_adelphi;
            }

            return result;
        },
        qtyOutlet(productCode) {
            let result = [];

            if (this.outlets.length > 0) {
                this.outlets.forEach((outlet) => {
                    result.push({
                        outlet_code: outlet.outlet_code,
                        quantity: this.getQtyOutlet(outlet.outlet_code, productCode),
                    });
                })
            }

            return result;
        },
        getQtyOutlet(outletCode, productCode) {
            let result = 0;
            const detailSelected = this.details.find((product) => product.product_code == productCode 
                && product.outlet_code == outletCode);

            if (detailSelected) {
                result = detailSelected.quantity;
            }

            return result;
        },
        getQtyOutlet2(outletCode) {
            let result = 0;
            const detailSelected = this.details.find((product) => product.outlet_code == outletCode);

            if (detailSelected) {
                result = detailSelected.quantity;
            }

            return result;
        },
        totalQtyOutlet(outletCode) {
            let result = 0;

            this.filteredItems.forEach((item) => {
                item.outlets.forEach((outlet) => {
                    if (outlet.outlet_code == outletCode) {
                        result += Number(outlet.quantity);
                    }
                });
            });

            return result;
        },
        calculateSisa(product) {
            let result = 0;

            result = Number(product.quantity_from_adelphi) - this.calculateTotal(product);

            return result;
        },
        calculateTotal(product) {
            let result = 0;

            if (product.outlets) {
                product.outlets.forEach((outlet) => {
                    result += Number(outlet.quantity);
                });
            }

            return result;
        },
        isWarning(product) {
            const result = this.calculateSisa(product);
            return result != 0 ? true : false;
        },
        async saveTester() {
            await this.$refs.testerform.validate();

            if (!this.valid) return;

            this.saveProgress = true;

            let dataItems = this.convertDataForServer();

            const result = await this.$store.dispatch('tester/save', {
                delivery_date: this.date,
                coordinator_code: this.selectedCoordinator,
                items: dataItems,
            });

            if (result.status == 200 | result.status == 201) {
                // this.$router.go(-1);
                this.$router.push(`/tester`);
                this.saved = true;
            } else {
                this.saveError = true;
            }

            this.saveProgress = false;
        },
        async updateTester() {
            await this.$refs.testerform.validate();
            if (!this.valid) return;

            try {
                this.saveProgress = true;

                let dataItems = this.convertDataForServer();
                const testerId = this.$route.params.id;
                const result = await this.$store.dispatch('tester/update', {
                    tester_id: testerId,
                    delivery_date: this.date,
                    coordinator_code: this.selectedCoordinator,
                    items: dataItems,
                });

                if (result.status == 200 | result.status == 201) {
                    this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Data tester berhasil diupdate'});
                    // this.$router.go(-1);
                    this.$router.push(`/tester`);
                    this.saved = true;
                } else {
                    this.saveError = true;
                }
            } catch (err) {
                const keyword = 'duplicate key'
                if (err.response.data.message.search(keyword) > -1){
                    return this.$store.commit('setSnackbar', {saveError: true, errorMessage: "Duplicate Key!"});
                }
                else {
                    return this.$store.commit('setSnackbar', {saveError: true, errorMessage: err.response.data.message});
                }
            } finally {
                this.saveProgress = false;
            }
        },
        convertDataForServer() {
            let dataItems = [];

            this.items.forEach((item) => {
                item.outlets.forEach((outlet) => {
                    dataItems.push({
                        outlet_code: outlet.outlet_code,
                        product_code: item.product_code,
                        quantity: outlet.quantity,
                        quantity_from_adelphi: item.quantity_from_adelphi,
                    });
                });
            })

            return dataItems;
        },
        export2xls() {
            const wb = utils.table_to_book(this.$refs.tabelExport.$el.firstChild.firstChild);
            writeFileXLSX(wb, "Tester.xlsx");
        }
    }
}
</script>

<style scoped>
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
    border-radius: 7px!important;
}

.text-input input {
  padding: 0 !important;
  border: none;
  background-color: #ffe169 !important;
}

.text-input ::v-deep .v-input__control {
  background-color: #ffe169 !important;
}

.text-input ::v-deep .v-input__slot {
  background-color: #ffe169 !important;
}

.text-input ::v-deep .v-input__control input {
  background-color: #ffe169 !important;
  text-align: center;
}

.text-input .v-input__slot {
    background-color: #ffe169 !important;
    text-align: center;
}

.text-center-input .v-input__slot {
    text-align: center;
}

.text-center-input ::v-deep .v-input__control input {
  text-align: center;
}

.spreadsheet-table {
  border-collapse: collapse;
  width: 100%;
}

.header-cell,
.spreadsheet-cell {
  border: 1px solid #ddd;
  padding: 8px !important;
  text-align: left;
  min-width: 100px;
}

.spreadsheet-cell {
  background-color: #f9f9f9;
  cursor: pointer;
  padding: 0px !important;
}

.spreadsheet-cell:focus-within {
  background-color: #e6f7ff;
  outline: none;
}

.spreadsheet-input {
  padding: 0 !important;
  margin: 0;
  border: none;
  box-shadow: none;
  background-color: transparent !important;
  font-size: inherit;
  width: 100%;
}

.spreadsheet-input input {
  padding: 0 !important;
  border: none;
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__slot {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control input {
  background-color: #ffe169 !important;
  text-align: center;
}

.spreadsheet-input .v-input__slot {
    background-color: #ffe169 !important;
    text-align: center;
}

.spreadsheet-cell .v-text-field.v-text-field--solo .v-input__control input {
  text-align: center !important;
}

.view {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}

.table-container {
  display: flex;
  margin-top: 20px;
  flex-grow: 1;
  overflow: hidden;
}

.flex-table {
  display: flex;
  flex-grow: 1;
  width: 100%;
}

.flex-table > div {
  width: 100%;
}

.disable-input input {
  padding: 0 !important;
  border: none;
  background-color: #E0E0E0 !important;
}

.disable-input ::v-deep .v-input__control {
  background-color: #E0E0E0 !important;
}

.disable-input ::v-deep .v-input__slot {
  background-color: #E0E0E0 !important;
}

.disable-input ::v-deep .v-input__control input {
  background-color: #E0E0E0 !important;
}

.disable-input .v-input__slot {
    background-color: #E0E0E0 !important;
}

.disable2-input input {
  padding: 0 !important;
  border: none;
  background-color: #F5F5F5 !important;
}

.disable2-input ::v-deep .v-input__control {
  background-color: #F5F5F5 !important;
}

.disable2-input ::v-deep .v-input__slot {
  background-color: #F5F5F5 !important;
}

.disable2-input ::v-deep .v-input__control input {
  background-color: #F5F5F5 !important;
}

.disable2-input .v-input__slot {
    background-color: #F5F5F5 !important;
}

.warning-input input {
  padding: 0 !important;
  border: none;
  background-color: #FBDADE !important;
}

.warning-input ::v-deep .v-input__control {
  background-color: #FBDADE !important;
}

.warning-input ::v-deep .v-input__slot {
  background-color: #FBDADE !important;
}

.warning-input ::v-deep .v-input__control input {
  background-color: #FBDADE !important;
  text-align: center;
}

.warning-input .v-input__slot {
    background-color: #FBDADE !important;
    text-align: center;
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}
</style>